















import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import {
  ExecYearmonthState,
  SET_EXEC_YEARMONTH
} from "@/store/modules/execYearmonth/types";
import Detail from "@/components/dashboard/detail.vue";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import { getDefaultMonth } from "@/types";

const StoreExecYearmonth = namespace("exec_yearmonth");

@Component({
  components: {
    Detail,
    LoadingDialog
  }
})
export default class BillingList extends mixins(AxiosMixin) {
  @State("exec_yearmonth") execYearmonthState!: ExecYearmonthState;
  @StoreExecYearmonth.Mutation(SET_EXEC_YEARMONTH) setExecYearmonth!: Function;

  //データテーブル
  private tableItems: object[] = [];

  //=================================================================
  // 処理済年月
  //=================================================================
  private get execYearmonth() {
    return this.execYearmonthState.exec_yearmonth;
  }
  private set execYearmonth(exec_yearmonth: string) {
    localStorage.setItem("exec_yearmonth", exec_yearmonth);
    this.setExecYearmonth(exec_yearmonth);
  }

  //=================================================================
  // 検索ボタン
  //=================================================================
  private search() {
    if (this.execYearmonth == "") {
      this.tableItems = [];
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/office/billinglistdetailsprintedat/get",
      {
        exec_yearmonth: this.execYearmonth.replace("-", "")
      },
      res => {
        this.tableItems = res.data.billinglist;
      }
    );
  }

  //=================================================================
  // ダウンロードボタン
  //=================================================================
  private download() {
    const param = {
      table_items: this.tableItems
    };

    const fname = `請求一覧（詳細/処理済月）_${this.execYearmonth}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/billinglistdetails/download",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //=================================================================
  // マウント
  //=================================================================
  //画面表示で検索をかける
  mounted() {
    const eym = localStorage.getItem("exec_yearmonth");
    this.execYearmonth = eym ? String(eym) : getDefaultMonth().substr(0, 7);
    this.search();
  }
}
